import React, { useState, useEffect, useContext, useRef } from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import SiteData from '../../config';
import expoHallAPI from '../../api/expoHallAPI';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Link, useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { setColor, setBoxShadow } from '../../styles/styles';
import { Context as UserContext } from '../../context/UserContext';
import { Context as AttendantContext } from '../../context/AttendantContext';
import { InformationalIcon } from '../../styles/icons';

const Register = ({ className }) => {
  const history = useHistory();

  const {
    state: { user },
    setUser,
  } = useContext(UserContext);
  const {
    state: { attendant },
    setAttendant,
  } = useContext(AttendantContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [company, setCompany] = useState('');
  const [screenName, setscreenName] = useState('');
  const [phoneNumber, setphoneNumber] = useState('');
  const [allowSave, setAllowSave] = useState(true);
  const [allowAutoPass, setAllowAutoPass] = useState(true);
  const [nabjMember, setNabjMember] = useState(true);
  const [visible, setvisible] = useState(false);
  const [alreadyExist, setalreadyExist] = useState(false);
  const [notInList, setNotInList] = useState(false);

  useEffect(() => {
    authenticateUser();
  }, []);

  const authenticateUser = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-user');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendee/profile/');
      if (data) {
        history.push('/');
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-user');
      setUser(undefined);
      authenticateAttendant();
    }
  };

  const authenticateAttendant = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendant/profile/');
      // console.log(data);
      if (data) {
        history.push('/dashboard');
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-attendant');
      setAttendant(undefined);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await expoHallAPI.post('/pre_register/', {
        //set as null any field they dont want
        first_name: firstName,
        last_name: lastName,
        email: email.toLowerCase(),
        //do you have a question
        company: company,
        //Are you an APA member?
        phone: phoneNumber,
        screen_name: screenName,
        schema: SiteData.schemaName,
        //two data questions
        allow_save: allowSave,
        allow_auto_pass: allowAutoPass,

        password: password,
        subject: 'APA Town Hall Part IV Registration Confirmation',
      });
      //history.push("/confirmation");
      const { data } = await expoHallAPI.post('/login/', {
        email: email.toLowerCase(),
        password,
        schema: SiteData.schemaName,
      });
      localStorage.setItem('shrm-li-expo-user', data.token);
      history.push('/login');
    } catch (error) {
      console.log(error);
      if (error.response) {
        if (error.response.status === 403) {
          console.log('already exisit');
          setNotInList(false);
          setalreadyExist(true);
        } else {
          setalreadyExist(false);
          setNotInList(true);
        }
      }
    }
  };
  return (
    <div className={className}>
      <div className="logo_overlay">
        <div className="logo_login">
          <img src={SiteData.loginImagesrc} alt={SiteData.loginImagealt} />
        </div>

        {alreadyExist && (
          <section>
            <div className="instruction-box">
              <div className="item">
                <div className="item-icon">
                  <InformationalIcon />
                </div>
                <div className="item-text">
                  A user with the email {alreadyExist} has already been created.
                  If you require assistance, please contact
                  spacessupport@matchboxvirtual.com
                </div>
              </div>
            </div>
          </section>
        )}
        {notInList && (
          <section>
            <div className="instruction-box">
              <div className="item">
                <div className="item-icon">
                  <InformationalIcon />
                </div>
                <div className="item-text">
                  There was an error creating your account. Please contact
                  spacessupport@matchboxvirtual.com for assistance
                </div>
              </div>
            </div>
          </section>
        )}
        <Form onSubmit={handleSubmit}>
          {/*the Field:  first name last name, Email, Are you a memeber, Company  */}
          <h3>{SiteData.loginTitle}</h3>
          <div className="Register_names">
            <TextField
              name="firstName"
              value={firstName}
              id="Filled-basic"
              type="Text"
              required
              label="First Name"
              variant="filled"
              className="register_Form_first"
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />

            <TextField
              name="lastName"
              value={lastName}
              id="Filled-basic"
              required
              type="Text"
              label="Last Name"
              variant="filled"
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
          </div>
          <TextField
            name="email"
            value={email}
            id="Filled-basic"
            required
            type="Email"
            label="Email"
            variant="filled"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <div className="passworddiv">
            <TextField
              name="password"
              id="Filled-password-input"
              label="Create Password"
              type={visible ? 'text' : 'password'}
              required
              value={password}
              autoComplete="current-password"
              variant="filled"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <div onClick={() => setvisible((prev) => !prev)} className="visile">
              {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </div>
          </div>
          <TextField
            name="screenname"
            value={screenName}
            id="Filled-basic"
            type="Text"
            label="Screen name"
            variant="filled"
            className="register_Form_first"
            onChange={(event) => {
              setscreenName(event.target.value);
            }}
          />

          <TextField
            name="company"
            value={company}
            id="Filled-basic"
            type="Text"
            label="Is there a question you would like the speakers to address?"
            variant="filled"
            className="register_Form_first"
            onChange={(event) => {
              setCompany(event.target.value);
            }}
          />

          {/* <TextField
						name="Phone"
						value={phoneNumber}
						id="Filled-basic"
						type="text"
						label="Phone "
						variant="filled"
						className="register_Form_first"
						onChange={(event) => {
							setphoneNumber(event.target.value);
						}}
					/> */}

          <div className="Register_checkbox">
            <div className="checkbox-Nabj-Container">
              <div className="checkbox-Nabj">
                <label
                  htmlFor="phoneNumber"
                  className="checkbox-label"
                  style={{ alignSelf: 'center' }}
                  required
                >
                  Are you an APA member?
                </label>
                <div className="buttonContainer">
                  <button
                    type="button"
                    className={
                      phoneNumber === 'yes'
                        ? 'buttonSelected'
                        : 'buttonNotSelected'
                    }
                    onClick={() => setphoneNumber('yes')}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className={
                      phoneNumber === 'no'
                        ? 'buttonSelected'
                        : 'buttonNotSelected'
                    }
                    onClick={() => setphoneNumber('no')}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
            {/* <div className="checkbox">
							<input
								checked={allowSave}
								type="checkbox"
								id="allowSave"
								name="allowSave"
								className="checkmark"
								onChange={() => setAllowSave((prevState) => !prevState)}
							/>
							<label for="allowSave">
								Allow us to save your information for the duration of the event
							</label>
						</div>
						<div className="checkbox">
							<input
								checked={allowAutoPass}
								type="checkbox"
								id="allowAutoPass"
								name="allowAutoPass"
								className="checkmark"
								onChange={() => setAllowAutoPass((prevState) => !prevState)}
							/>
							<label for="allowAutoPass">
								Allow us to share your information with event organizers
							</label>
						</div> */}
            <p>
              By registering for this event you are agreeing to share this
              information with Matchbox Virtual Media and event organizers
            </p>
          </div>

          <Button
            // disabled={!email && !password}
            type="submit"
            disabled={
              !email ||
              !password ||
              !firstName ||
              !lastName ||
              nabjMember === null
            }
          >
            Register
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default styled(Register)`
  display: flex;
  flex-direction: column;
  background: #ffffffad;
  flex-direction: column;
  width: 100vh;
  margin: auto;
  opacity: 1;
  color: black;

  /* justify-content: center; */
  .passworddiv {
    position: relative;
    svg {
      position: absolute;
      bottom: 25%;
      right: 1%;
      fill: ${SiteData.secondary_color};
    }
  }

  .MuiFormLabel-root {
    font-size: 20px;
    color: grey;
  }
  .MuiFilledInput-root {
    width: 100%;
  }
  .MuiFormControl-root {
    display: block;
    width: 100%;
    margin-bottom: 10px;
  }
  .Register_names {
    display: flex;
  }
  .register_Form_first {
    margin-right: 10px;
  }

  .MuiFilledInput-underline:after {
    border-bottom: 2px solid ${SiteData.primary_color};
  }
  .MuiInputBase-input {
    background-color: white;
    font-size: 15px;
  }
  .checkbox {
    color: black;
    align-self: center;
    font-family: sans-serif;
    .checkmark {
      margin-right: 10px;
    }
  }
  .checkbox-Nabj-Container {
    padding: 0 10px;
    min-height: 50px;
    background-color: #fff;
    display: flex;
    margin-bottom: 40px;
  }

  .checkbox-Nabj {
    color: black;
    width: 100%;
    align-self: center;
    display: flex;
    justify-content: space-between;
    font-family: sans-serif;
    .buttonContainer {
      display: flex;
      justify-content: space-around;
      width: 20%;
    }
    .buttonNotSelected {
      display: flex;
      padding: 0.5rem;
      background-color: #fff;
      color: ${SiteData.primary_color};
      border: 1px solid ${SiteData.primary_color};
      border-radius: 3px;
      font-weight: bold;
      font-size: 14px;
      transition: background-color 0.3s ease;
      cursor: pointer;
      :hover {
        background-color: ${SiteData.secondary_color};
        color: #fff;
      }
      :focus {
        border: 1px solid ${SiteData.primary_color};
      }
    }
    .buttonSelected {
      display: flex;
      padding: 0.5rem;
      background-color: ${SiteData.primary_color};
      color: white;
      border: 1px solid ${SiteData.primary_color};
      border-radius: 3px;
      font-weight: bold;
      font-size: 14px;
      transition: background-color 0.3s ease;
      cursor: pointer;
      :hover {
        background-color: ${SiteData.secondary_color};
        color: #fff;
      }
      :focus {
        border: 1px solid ${SiteData.primary_color};
      }
    }
  }
  .checkbox-label {
    font-size: 1rem;
    font-weight: 500;
  }
  .whitewash {
    background: white;
  }

  .instruction-box {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin: auto;
  }

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 2px solid #8b0000c7;
    padding: 10px;
    border-radius: 10px;
    :not(:last-child) {
      margin-bottom: 2rem;
    }
    .item-icon {
      height: 3rem;
      width: 3rem;
      fill: #8b0000c7;
      padding: 0.5rem;
    }
    .item-text {
      font-size: 1rem;
      margin-left: 1rem;
      font-weight: 500;
      /* max-width: 300px; */
    }
  }
  .logo_login {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (max-width: 600px) {
    background: #f5f1f14f;
    width: 50vh;
    // img {
    // 	margin: 0;
    // 	height: 150px !important;
    // 	padding: 0 5%;
    // 	width: 90%;
    // }
    .logo_login {
      display: flex;
      align-items: center;
    }
    form {
      margin: 0;
    }
    .checkbox-Nabj-Container {
      margin-bottom: 5px;
    }
    .checkbox > label {
      color: #fff;
    }
    .checkbox-Nabj > .buttonContainer {
      width: 28%;
    }
  }
`;

const Form = styled.form`
  margin: 0 auto;
  padding: 0 1rem 1rem;
  border-radius: 10px;

  h3 {
    //color: ${SiteData.backgroundColor};
    color: black;
    margin-left: 0.5rem;
    font-size: 2rem;
  }
`;

const Button = styled.button`
  margin-top: 0.5rem;
  width: fit-content;
  padding: 1rem 2rem;
  margin-left: auto;
  display: flex;
  background-color: ${SiteData.primary_color};
  color: white;
  border: none;
  border-radius: 3px;
  font-weight: bold;
  font-size: 20px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.3s ease;
  :hover {
    background-color: ${SiteData.secondary_color};
  }
`;
